import React from 'react';
import './EmailVerificationModal.css';

interface EmailVerificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
}

const EmailVerificationModal: React.FC<EmailVerificationModalProps> = ({ isOpen, onClose, email }) => {
  if (!isOpen) return null;

  const handleContactSupport = () => {
    window.open('mailto:hello.humanizador@gmail.com', '_blank');
  };

  return (
    <div className="email-verification-modal-overlay" onClick={onClose}>
      <div className="email-verification-modal" onClick={e => e.stopPropagation()}>
        <div className="verification-modal-content">
          <h2>Verifique seu email</h2>
          
          <p className="verification-instruction">
            Clique no link que enviamos para{' '}
            <strong>{email}</strong> para finalizar o login.
          </p>

          <div className="verification-help">
            <h3>Não recebeu?</h3>
            <p>
              Pode levar alguns minutos para chegar — e não se esqueça de 
              verificar sua pasta de spam.
            </p>
            
            <p>
              Ainda nada?{' '}
              <button 
                className="contact-link"
                onClick={handleContactSupport}
              >
                Entre em contato conosco em hello.humanizador@gmail.com
              </button>
            </p>
          </div>

          <button 
            className="verification-close-btn"
            onClick={onClose}
          >
            Entendi
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationModal;